import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import t from '@/utils/Language/ResourceCard-translations';
import classes from './VirtualAvailableBadge.module.scss';

const VirtualAvailableBadge = ({ resource }) => {
  if (!resource?.properties?.['is-available-virtually']) {
    return null;
  }

  return (
    <div className={classes.virtualBadge}>
      <FontAwesomeIcon icon="fa-solid fa-video" className={classes.videoIcon} />
      <span>{t('Virtual Available')}</span>
    </div>
  );
};

export default VirtualAvailableBadge;
